module.exports = __webpack_public_path__ + "assets/img/my-vpp-bg-n.45242200.png";